import { Injectable } from '@angular/core';
import { Inspection } from './inspection.dto';
import { Observable, startWith } from 'rxjs';
import { ChangeTyped, SearchResult } from '@damofire/data-commons';
import { TypedDesQuery } from '../des.dto';
import { ObservableNoteService } from '../note/note-observable.service';
import { ObservableNoteableService } from '../note/noteable-observable.service';
import { Note, Noteable } from '../note/note.dto';

@Injectable()
export abstract class ObservableInspectionService extends ObservableNoteableService<Inspection> {
  protected readonly SEARCH_FIELDS = ['name'];
  protected readonly notesFilterFn = (note: Note, inspection: Noteable): boolean => inspection._id === note.inspection._id;

  protected constructor(protected readonly observableNoteService: ObservableNoteService) {
    super(observableNoteService);
  }

  protected abstract observeById(division: string, inspectionId: string): Observable<ChangeTyped<Inspection>>;

  observeInspection(divisionId: string, inspectionId: string): Observable<ChangeTyped<Inspection>> {
    const noteableSub = this.observeById(divisionId, inspectionId);
    const noteSub = this.observableNoteService.observeNotes(divisionId, inspectionId).pipe(startWith([]));
    return this.combineNoteableNotes(noteSub, noteableSub);
  }

  search(id: string, sQuery: TypedDesQuery): Observable<SearchResult<Inspection>> {
    return super.searchByDivision(id, sQuery);
  }
}
